import Promise from 'promise-polyfill'

window.Promise = window.Promise || Promise



// WEBPACK FOOTER //
// ./client/promise-polyfill.js